import type { PlayerSnapshot } from '@/net/protocol'

/** CS-style scoreboard: held with the ` key, lists every connected player and
 * their ping (reported per-player by the server). Writes to #scoreboard. */
export default class Scoreboard {
  private readonly root = document.getElementById('scoreboard')
  private readonly body = document.getElementById('scoreboard-body')
  private readonly count = document.getElementById('scoreboard-count')
  private visible = false

  public setVisible(visible: boolean): void {
    this.visible = visible
    this.root?.classList.toggle('hidden', !visible)
  }

  public toggle(): void {
    this.setVisible(!this.visible)
  }

  public get isVisible(): boolean {
    return this.visible
  }

  /** Rebuild the rows (cheap; only runs while the board is shown). */
  public update(players: PlayerSnapshot[], selfId: string): void {
    if (!this.visible || !this.body) return
    const sorted = [...players].sort((a, b) => {
      if (a.id === selfId) return -1
      if (b.id === selfId) return 1
      return a.ping - b.ping
    })
    if (this.count) this.count.textContent = String(players.length)
    this.body.innerHTML = sorted
      .map((p) => {
        const you = p.id === selfId
        const name = you ? 'YOU' : 'P-' + p.id.slice(0, 4)
        const grade = p.ping < 80 ? 'good' : p.ping < 150 ? 'mid' : 'bad'
        return (
          `<div class="sb__row${you ? ' sb__row--you' : ''}${p.alive ? '' : ' sb__row--dead'}">` +
          `<span class="sb__name">${name}</span>` +
          `<span class="sb__state">${p.alive ? 'alive' : 'dead'}</span>` +
          `<span class="sb__ping sb__ping--${grade}">${p.ping} ms</span>` +
          `</div>`
        )
      })
      .join('')
  }
}
